import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSavingsOpportunitiesViewsHierarchyThunk } from "@/store/savings-opportunities/thunks/views-hierarchy/getSavingsOpportunitiesViewsHierarchyThunk";
import { getOrganisationCurrentFilterTemplatesThunk } from "@/store/live-usage-mgmt/thunks/getOrganisationCurrentFilterTemplatesThunk";
import { getSavingsOpportunitiesThunk } from "@/store/savings-opportunities/thunks/data-getters/getSavingsOpportunitiesThunk";
import { FilterTreeNode } from "@/services/cloudchipr.api";

export const initiateSavingsOpportunitiesThunk = createAsyncThunk(
  "savingsOpportunities/initiateSavingsOpportunities",
  async (filterTree: FilterTreeNode | void, { dispatch }) => {
    dispatch(getOrganisationCurrentFilterTemplatesThunk());

    await dispatch(getSavingsOpportunitiesViewsHierarchyThunk());
    await dispatch(getSavingsOpportunitiesThunk(filterTree));
  },
);
